import api from "@/api";

export default {
  async getLocationPVForeCast({ commit }, obj) {
    commit("REQUEST_PV_FORECAST_LOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_PV_FORECAST_LOCATION",
        await api.getLocationPVForeCast(obj)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_PV_FORECAST_LOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getFcSolarHa({ commit }, obj) {
    commit("REQUEST_SOLAR_HA");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_SOLAR_HA",
        await api.getFcSolarHa(obj)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_SOLAR_HA");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  
  async getMixPrice({ commit }, obj) {
    commit("REQUEST_MIX_PRICE");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.getMixPrice(obj);
      commit("SUCCESS_REQUEST_MIX_PRICE", result);
      return result;
    } catch (err) {
      commit("FAILURE_REQUEST_MIX_PRICE");
      return null;
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
